import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Nav from "./Nav";
import MobileMenu from "./MobileMenu";
import { useGeneralSheetHook } from "../../hooks/sheet.hook";
import { removeSpaces } from "../data";

const HeaderComponent = () => {
  const publicUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL + "/" : "/";

  const sheet_data = useGeneralSheetHook();

  return (
    <header className="main-header clearfix">
      <div className="main-header__top clearfix">
        <div className="container clearfix">
          <div className="main-header__top-inner clearfix">
            <div className="main-header__top-left">
              <ul className="list-unstyled main-header__top-address">
                <li>
                  <div className="icon">
                    <span className="icon-call"></span>
                  </div>
                  <div className="text">
                    <p>
                      <a
                        href={`tel:${removeSpaces(sheet_data.phone_number_1)}`}
                      >
                        +{sheet_data.phone_number_1.replace("`", "")}
                      </a>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <span className="icon-call"></span>
                  </div>
                  <div className="text">
                    <p>
                      <a
                        href={`tel:${removeSpaces(sheet_data.phone_number_2)}`}
                      >
                        +{sheet_data.phone_number_2.replace("`", "")}
                      </a>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <span className="icon-envelope"></span>
                  </div>
                  <div className="text">
                    <p>
                      <a href={`mailto:${sheet_data.email}`}>
                        {sheet_data.email}
                      </a>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <nav className="main-menu clearfix">
        <div className="container clearfix">
          <div className="main-menu-wrapper clearfix">
            <div className="main-menu-wrapper__left">
              <div className="main-menu-wrapper__logo">
                <Link to={publicUrl}>
                  <img
                    src={`${publicUrl}assets/images/resources/logo-1.png`}
                    alt="Logo"
                    style={{ maxWidth: "280px", maxHeight: "64px" }}
                  />
                </Link>
              </div>
            </div>
            <div className="main-menu-wrapper__right">
              <div className="main-menu-wrapper__main-menu">
                <MobileMenu generalApi={{ ...sheet_data }} />
                <Nav generalApi={{ ...sheet_data }} />
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

HeaderComponent.propTypes = {
  generalApi: PropTypes.shape({
    email: PropTypes.string,
  }),
};

HeaderComponent.defaultProps = {
  generalApi: { email: "" },
};

export default HeaderComponent;
